export default __webpack_public_path__ + "static/media/H1006.b6b2dd87.mp3";